<template>
  <div v-if="isAnonymousUser" class="login-banner">
    <div class="login-banner-content">
      <div class="login-banner-text">
        <span class="material-icons-outlined login-icon">lock</span>
        <div class="login-text">
          <h3>Acceso completo al informe semanal</h3>
          <p>Inicia sesión para acceder a todos los informes y contenido exclusivo</p>
        </div>
      </div>
      <div class="login-banner-actions">
        <button @click="goToLogin" class="login-btn primary">
          <span class="material-icons">login</span>
          Iniciar sesión
        </button>
        <button @click="goToRegister" class="login-btn secondary">
          <span class="material-icons">person_add</span>
          Registrarse
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LoginBanner',
  computed: {
    ...mapGetters(['_g_UserId']),
    isAnonymousUser() {
      return this._g_UserId === 0;
    }
  },
  methods: {
    goToLogin() {
      // Store the current informe path to redirect after login
      localStorage.setItem('user_location_before_login', 'InformeLogin');
      localStorage.setItem('informe_path_for_redirect', this.$route.fullPath);
      this.$router.push('/app/login');
    },
    goToRegister() {
      // Store the current informe path to redirect after registration
      localStorage.setItem('user_location_before_login', 'InformeLogin');
      localStorage.setItem('informe_path_for_redirect', this.$route.fullPath);
      this.$router.push('/app/informe/register');
    }
  }
};
</script>

<style lang="scss" scoped>
.login-banner {
  background: linear-gradient(135deg, var(--color-primary) 0%, #0056b3 100%);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
  position: relative;

  // Add decorative elements
  &::before {
    content: '';
    position: absolute;
    top: -20px;
    right: -20px;
    width: 120px;
    height: 120px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -30px;
    left: -30px;
    width: 150px;
    height: 150px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
    z-index: 0;
  }
}

.login-banner-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  z-index: 1;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.login-banner-text {
  display: flex;
  align-items: center;
  gap: 16px;
  color: white;

  .login-icon {
    font-size: 32px;
    color: rgba(255, 255, 255, 0.9);
  }

  .login-text {
    h3 {
      margin: 0 0 8px 0;
      font-size: 20px;
      font-weight: 700;
      color: white;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    }

    p {
      margin: 0;
      font-size: 16px;
      color: white;
      opacity: 0.95;
      line-height: 1.5;
    }
  }
}

.login-banner-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 16px;
  }
}

.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  white-space: nowrap;
  text-decoration: none;

  .material-icons {
    font-size: 20px;
  }

  &.primary {
    background-color: white;
    color: var(--color-primary);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

    &:hover {
      background-color: white;
      transform: translateY(-3px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
    }
  }

  &.secondary {
    background-color: rgba(255, 255, 255, 0.2);
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(10px);

    &:hover {
      background-color: rgba(255, 255, 255, 0.3);
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
    }
  }
}
</style> 